<template>
    <div v-show="inline || visible" :class="inline ? 'workforce-history-inline' : 'workforce-history-layer'">
        <button v-if="!inline" type="button" class="workforce-history-backdrop"
                aria-label="Закрыть историю изменений" @click="$emit('close')"></button>
        <section :class="inline ? 'workforce-history-inline__panel' : 'workforce-history'"
                 :role="inline ? 'region' : 'dialog'" :aria-modal="inline ? null : 'true'"
                 aria-label="История изменений доски и плана">
            <header class="workforce-history__header">
                <button v-if="inline" type="button" class="workforce-history-inline__toggle"
                        :aria-expanded="expanded ? 'true' : 'false'" @click="expanded = !expanded">
                    <i class="fas" :class="expanded ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
                    История изменений
                </button>
                <div v-else><div class="workforce-history__eyebrow">Доска и план сотрудников</div><h2>История изменений</h2></div>
                <button v-if="!inline" type="button" class="workforce-history__close" aria-label="Закрыть"
                        @click="$emit('close')"><i class="fas fa-times" aria-hidden="true"></i></button>
            </header>
            <employee-workforce-history-content v-if="openedOnce" v-show="opened" :active="opened"
                :class="{'workforce-history-content--inline': inline}"
                :object-options="objectOptions" :refresh-token="refreshToken"
                @open-employee="$emit('open-employee', $event)" />
        </section>
    </div>
</template>

<script>
import EmployeeWorkforceHistoryContent from './EmployeeWorkforceHistoryContent.vue';
export default {
    name: 'EmployeeWorkforceHistory',
    components: {EmployeeWorkforceHistoryContent},
    props: {
        visible: {type: Boolean, default: false},
        inline: {type: Boolean, default: false},
        objectOptions: {type: Array, default: () => []},
        refreshToken: {type: Number, default: 0}
    },
    data() { return {expanded: false, openedOnce: false}; },
    computed: {opened() { return this.inline ? this.expanded : this.visible; }},
    watch: {opened: {immediate: true, handler(value) { if (value) this.openedOnce = true; }}}
};
</script>

<style scoped>
.workforce-history-layer {
    position: fixed;
    z-index: 1095;
    inset: 0;
    overflow: hidden;
}

.workforce-history-backdrop {
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 0;
    border: 0;
    background: rgba(24, 34, 45, 0.3);
}

.workforce-history {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    width: min(560px, 94vw);
    min-height: 0;
    overflow: hidden;
    background: #fff;
    box-shadow: -10px 0 30px rgba(24, 34, 45, 0.22);
}

.workforce-history__header {
    display: flex;
    flex: 0 0 auto;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 20px 22px 16px;
    border-bottom: 1px solid #e3e8ee;
}

.workforce-history__header h2 {
    margin: 0;
    color: #253545;
    font-size: 1.25rem;
}

.workforce-history__eyebrow {
    margin-bottom: 3px;
    color: #7a8794;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.workforce-history__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: #eef2f6;
    color: #506174;
}


.workforce-history-inline { margin-top: 16px; border: 1px solid #dce5ee; border-radius: 8px; background: #fff; }
.workforce-history-inline .workforce-history__header { padding: 12px 16px; }
.workforce-history-inline__toggle { display: flex; align-items: center; gap: 10px; width: 100%; border: 0; background: transparent; color: #33485c; font-weight: 600; text-align: left; }
.workforce-history-content--inline { height: 560px; max-height: 75vh; }
@media (max-width: 575.98px) {
    .workforce-history { top: 5vh; width: 100%; max-height: 95vh; max-height: 95dvh; border-radius: 14px 14px 0 0; }
    .workforce-history__header { padding: 16px 15px 13px; }
}
</style>
